<template>
  <header>
    <h5>
      <router-link class="" :to="{ name: 'Layer', params: { uuid: feature.layer.id } }">
        {{ feature.layer.name }}
      </router-link>
      <span class='text-muted'>&raquo;</span>
    </h5>
    <h1>{{ feature.name }}</h1>
  </header>
</template>

<script>
export default {
  props: ["feature"]
}
</script>



// WEBPACK FOOTER //
// src/components/Feature/BreadcrumbHeader.vue